var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8919_11428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6501 9.9775C16.6501 5.86 13.4551 3.0625 9.90015 3.0625C6.38265 3.0625 3.15015 5.8 3.15015 10.0225C2.70015 10.2775 2.40015 10.7575 2.40015 11.3125V12.8125C2.40015 13.6375 3.07515 14.3125 3.90015 14.3125H4.65015V9.7375C4.65015 6.835 6.99765 4.4875 9.90015 4.4875C12.8026 4.4875 15.1501 6.835 15.1501 9.7375V15.0625H9.15015V16.5625H15.1501C15.9751 16.5625 16.6501 15.8875 16.6501 15.0625V14.1475C17.0926 13.915 17.4001 13.4575 17.4001 12.9175V11.1925C17.4001 10.6675 17.0926 10.21 16.6501 9.9775Z",
    fill: "#23BA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65021 11.3125C8.06442 11.3125 8.40021 10.9767 8.40021 10.5625C8.40021 10.1483 8.06442 9.8125 7.65021 9.8125C7.23599 9.8125 6.90021 10.1483 6.90021 10.5625C6.90021 10.9767 7.23599 11.3125 7.65021 11.3125Z",
    fill: "#23BA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1502 11.3125C12.5644 11.3125 12.9002 10.9767 12.9002 10.5625C12.9002 10.1483 12.5644 9.8125 12.1502 9.8125C11.736 9.8125 11.4002 10.1483 11.4002 10.5625C11.4002 10.9767 11.736 11.3125 12.1502 11.3125Z",
    fill: "#23BA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4002 9.085C14.0402 6.9475 12.1802 5.3125 9.93775 5.3125C7.66525 5.3125 5.22025 7.195 5.41525 10.15C7.26775 9.3925 8.66275 7.7425 9.06025 5.7325C10.0427 7.705 12.0602 9.0625 14.4002 9.085Z",
    fill: "#23BA50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8919_11428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.900085 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.1bff12d0e40b0b5f85996ec6c0bc86cb.svg";
export { ForwardRef as ReactComponent };